<template>
    <!-- 导航 -->
    <div class="content">
        <NavBar
            class="nav"
            :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'"
        >
            <template v-slot:title>
                <span class="nav-title">碎片合成</span>
            </template>
        </NavBar>

        <main>
            <div class="dateBox">
                <div class="cont-box">
                    <div class="top-img">
                        <img :src="product.cover" alt=""/>
                    </div>
                    <!--  -->
                    <div class="cont-bottom">
                        <div class="detail-box">
                            <!--  -->
                            <div class="name">{{ product.name }}</div>
                            <!--  -->
                            <div class="xl-list" v-if="product.tags && product.tags.length">
                                <div class="item" v-for="tag in product.tags" :key="tag.id">{{ tag.name }}</div>
                            </div>
                            <!--  -->
                            <div class="ref" v-if="product.organization">
                                <div class="ref-hea">创作者</div>
                                <div class="ref-con">{{ product.organization.name }}</div>
                            </div>
                            <div class="ref" v-if="product.issuer">
                                <div class="ref-hea">发行方</div>
                                <div class="ref-con">{{ product.issuer.name }}</div>
                            </div>
                            <!--  -->
                            <div class="line"></div>

                            <!--  -->
                            <p class="compound">合成材料</p>
                            <div class="list-item">
                                <div class="item" :class="{que: exists.indexOf(need.id) == -1, consume: need.isCatalyst}" v-for="need in product.needs" :key="need.id">
                                    <img :src="need.cover" />
                                    <img class="icon-jia" src="@/assets/images/jia.png" />
                                </div>
                            </div>

                            <!--  -->
                            <div class="btn-box">
                                <div class="btn-text-box waiting" v-if="product.state == states.waiting">
                                    <p class="title">等待开放</p>
                                    <p class="btn-time">开始时间 {{ dateFormat('mm.dd-HH:ii', product.release_time) }}</p>
                                </div>
                                <div class="btn-text-box active" v-else-if="product.state == states.normal" @click="compose">
                                    <p class="title">藏品合成</p>
                                    <p class="btn-time" v-if="Date.parse(new Date(product.offline_time))">结束时间 {{ dateFormat('mm.dd-HH:ii', product.offline_time) }}</p>
                                </div>
                                <div class="btn-text-box disable" v-else>
                                    <p class="title">{{ product.state == states.offline ? '已结束' : '已抢光' }}</p>
                                </div>
                                <p class="fangga">合成方式：{{ product.composeType ? (product.composeType == 1 ? '消耗合成' : '催化剂合成') : '非消耗合成' }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="explain-box">
                    <div class="txt-box">
                        <p class="tex-head">合成说明</p>

                        <p class="txt-cont">
                            【消耗合成】合成将消耗所有原始合成材料
                        </p>
                        <p class="txt-cont">
                            【非消耗合成】合成后原始合成材料全部保留
                        </p>
                        <p class="txt-cont">
                            【催化剂合成】合成后原始材料消耗，催化剂合成材料将保留
                        </p>
                    </div>
                </div>
            </div>
        </main>

        <div class="login" v-if="false">
            <div class="succ-box">
                <div class="close"></div>
                <div class="words">
                    <div>
                        <p style="line-height: 26px">
                            合成将消耗所有原始合成材料，是否确认合成？
                        </p>
                    </div>
                </div>
                <div class="is-btn btn-go-login">
                    <div class="btn_left">再想想</div>
                    <div class="btn_right">确认合成</div>
                </div>
            </div>
        </div>
    </div>
    <van-overlay :show="successType == 'confirm'" class="success-overlay">
        <div class="confirm">
            <img :src="product.cover" class="cover">
            <p class="title">合成成功</p>
            <router-link :to="'/entity/' + entityKey" class="button">查看详情</router-link>
        </div>
    </van-overlay>
    <van-overlay :show="showWelfareAlert" class="success-overlay">
        <div class="unpack">
            <img src="@/assets/images/blindbox.png" class="blindbox">
            <p class="title">获得福利</p>
            <a href="javascript:;" class="button" @click="showWelfareAlert = false;showWelfareInfo = true;">打开福利</a>
            <img src="@/assets/images/close.png" class="close" @click="welfareIndex = welfareIndex + 1;showWelfareAlert = welfares.length > welfareIndex">
        </div>
    </van-overlay>
    <van-overlay :show="showWelfareInfo" class="success-overlay">
        <div class="welfare" v-if="! welfares[welfareIndex].code">
            <img src="@/assets/images/close.png" class="close" @click="showWelfareInfo = false;welfareIndex = welfareIndex + 1;showWelfareAlert = welfares.length > welfareIndex">
            <img :src="welfares[welfareIndex].cover" class="cover">
            <img src="@/assets/images/welfare_line.png" class="line">
            <p class="title">{{ welfares[welfareIndex].name }}</p>
            <p class="title">领取说明</p>
            <pre class="description">{{ welfares[welfareIndex].description }}</pre>
            <router-link :to="'/welfare/' + welfares[welfareIndex].id" class="button">填写联系方式</router-link>
        </div>
        <Redeem :id="welfares[welfareIndex].id" :code="welfares[welfareIndex].code" :platform="welfares[welfareIndex].use" @close="showWelfareInfo = false;welfareIndex = welfareIndex + 1;showWelfareAlert = welfares.length > welfareIndex" v-else></Redeem>
    </van-overlay>
</template>

<script src="./Page.js"></script> 

<style src="./Page.scss" lang="scss" scoped></style>